import { render, staticRenderFns } from "./addCanalInvite.vue?vue&type=template&id=5a578cb8&scoped=true&"
import script from "./addCanalInvite.vue?vue&type=script&lang=js&"
export * from "./addCanalInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a578cb8",
  null
  
)

export default component.exports